import {
  Component, Output,
  Input, OnInit, ViewEncapsulation, inject, ViewChild, ViewContainerRef, ChangeDetectorRef
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_GRID, GridSize } from '@progress/kendo-angular-grid';
import { KENDO_SVGICON } from '@progress/kendo-angular-icons';
import { KENDO_BREADCRUMB } from '@progress/kendo-angular-navigation';
import { arrowRightIcon, arrowUpIcon, saveIcon, editToolsIcon, paperclipIcon, pencilIcon, plusIcon, uploadIcon } from '@progress/kendo-svg-icons';
import { catchError, finalize, forkJoin, Observable, Subscription, tap, throwError } from 'rxjs';
import { LayoutModule } from "@progress/kendo-angular-layout";
import { InputsModule, TextBoxComponent } from '@progress/kendo-angular-inputs';

import { LabelModule } from '@progress/kendo-angular-label';
import { KENDO_DROPDOWNS } from "@progress/kendo-angular-dropdowns";
import { FormControl, FormsModule, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { process } from '@progress/kendo-data-query';

import { SheetDescriptor, CellDefaultStyle, SheetRow, SpreadsheetMainMenuItem, SpreadsheetChangeEvent, DocumentDescriptor, SpreadsheetExcelExportEvent, SpreadsheetComponent, KENDO_SPREADSHEET, SpreadsheetBackColorComponent, SpreadsheetForeColorComponent } from "@progress/kendo-angular-spreadsheet";
import { DialogRef, DialogService, DialogsModule } from '@progress/kendo-angular-dialog';
import { SVGIcon, fileExcelIcon, xIcon, gearIcon, changeManuallyIcon, copyIcon, questionCircleIcon } from '@progress/kendo-svg-icons';
import { Projects, Objects, emptyObjects, Companies, CompaniesItem, companiesDefault } from '../../../_models/admin';
import { PortalAdminService } from '../../../_services/portal-admin.service';
import {
  KENDO_NOTIFICATION,
  NotificationService
} from "@progress/kendo-angular-notification";
import { ExcelExportEvent } from '@progress/kendo-angular-treelist';


@Component({
  selector: 'app-objects',
  imports: [KENDO_SVGICON, KENDO_BUTTON, KENDO_GRID, KENDO_BREADCRUMB, KENDO_NOTIFICATION, KENDO_DROPDOWNS, KENDO_SPREADSHEET,
    DialogsModule,
    LayoutModule, CommonModule, DropDownListModule, InputsModule, LabelModule, FormsModule, ReactiveFormsModule
  ],
  templateUrl: './objects.component.html',
  styleUrl: './objects.component.css',
  encapsulation: ViewEncapsulation.None
})
export class ObjectsComponent {
  portalAdminService = inject(PortalAdminService);
  searchTerm: string = '';
  adminObjects: Objects[] = [];
  displayObjects: Objects[] = [];
  checkObjects: Objects[] = [];
  selection: any[] = [];
  adminCompanies: Companies[] = [];
  buttonshidden: boolean = false;
  addbuttonstate: boolean = false;
  removebuttonstate: boolean = true;
  savebuttonstate: boolean = true;
  duplicateOrderName: boolean = false;
  uploadbuttonstate: boolean = false;
  readonly: boolean = false;
  loading: boolean = false;
  companiesLoading: boolean = false;
  selectedRowItem: any[] = [];
  pageSize: number = 30;
  initialFormValues!: Projects;
  selectedProjectId!: number;
  subscription: Subscription[] = [];
  companiesItems: CompaniesItem[] = [];
  companiesDefault: CompaniesItem = companiesDefault();
  selectedCompanyItem!: CompaniesItem;
  excelSVG: SVGIcon = fileExcelIcon;
  showErrorDialog: boolean = false;
  errorMessage: string = '';
  errorWindow = false;
  title = '';
  content = '';
  errorMessages: string[] = ['av', 'avb', 'avm', 'avn'];
  public iconNames: SVGIcon[] = [plusIcon, xIcon, saveIcon, uploadIcon, gearIcon, editToolsIcon, copyIcon, changeManuallyIcon, questionCircleIcon];
  public smallSize: GridSize = 'small';
  @Input() selprojectid!: number;
  private _project: any;

  @Input()
  set project(value: any) {
    this._project = value;

    if (value) {
      console.log('Project:', value);
    }
  }

  get project(): any {
    return this._project;
  }


  public form: FormGroup = new FormGroup({
    id: new FormControl(),
    projectid: new FormControl(),
    name: new FormControl(),
    description: new FormControl(),
    objectType: new FormControl(),
    enabled: new FormControl()
  });

  constructor(
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) {
    this.getObjects();
  }
  ngOnInit(): void {
    this.buttonhandle('Init');
    //this.getObjects();
    this.getAdminCompanies();
    this.buildform();
    console.log(this.project)

    //this.getAdminObjects(this.project?.projectId!);

    if (this.project?.projectId! != null) {
      this.uploadbuttonstate = false;
      this.addbuttonstate = false;
    }
  }

  getObjects() {
    this.subscription.push(
      this.portalAdminService.projectSubject.subscribe({
        next: (data) => {
          this.getAdminObjects(data.projectId!);
          if (data.projectId! != null) {
            this.uploadbuttonstate = false;
            this.addbuttonstate = false;
          }
        },
        error: (error) => {
          console.log(error);
        },
        complete: () => {
          console.log('completed ');
        },
      }),
    );
  }

  getAdminCompanies() {
    this.companiesLoading = true;
    this.adminCompanies = [];


    this.portalAdminService.getCompanies().subscribe({
      next: (result) => {
        this.adminCompanies = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        this.companiesLoading = false;
      },
      complete: () => {
        for (let i = 0; i < this.adminCompanies.length; i++) {

          const data =
            { text: this.adminCompanies[i].companyName+" ("+this.adminCompanies[i].recipientCode+")", value: this.adminCompanies[i].companyId };
          this.companiesItems.push(data);
        }
        this.companiesLoading = false;
        //console.log(JSON.stringify(this.adminCompanies));
      }
    });
  }

  public onFilter(inputValue: string): void {
    console.log('onFilter() calling');
    // this.searchTerm = inputValue;
    // this.form.reset();
    // this.selection = [];
    // this.form.disable();
    // this.buttonhandle('Filter');

    this.displayObjects = process(this.adminObjects, {
      filter: {
        logic: 'or',
        filters: [
          {
            field: 'name',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'description',
            operator: 'contains',
            value: inputValue,
          },
          {
            field: 'companyName',
            operator: 'contains',
            value: inputValue,
          },

        ],
      },
    }).data;

  }
  buildform() {
    this.form.enable();
    this.form = this.formBuilder.group({
      id: null,
      projectid: null,
      name: ['', [Validators.required, Validators.minLength(2)]],
      description: [null, [Validators.required, Validators.minLength(2)]],
      company: [this.companiesDefault, [Validators.required, Validators.required]],
      objectType: ['Purchase Order'],
      enabled:['T']
    });
    this.form.disable();
  }

  buttonhandle(action: string) {
    this.addbuttonstate = true;
    this.removebuttonstate = true;
    this.savebuttonstate = true;
    this.uploadbuttonstate = true
    // console.log(action)
    // if (action === 'Init') {
    //   this.uploadbuttonstate = true;
    // }

    if (action === 'Click') {
      this.addbuttonstate = false;
      this.removebuttonstate = false;
      this.uploadbuttonstate = false;
    }

    if (action === 'Filter') {
      this.addbuttonstate = false;
    }
    if (action === 'Remove') {
      this.addbuttonstate = false;
    }

    if (action === 'Save') {
      this.addbuttonstate = false;
    }
  }

  onCellClick(event: any) {
    const companyid = this.companiesItems.findIndex((x) => x.value === event.dataItem.companyId);
    this.buttonhandle('Click');
    this.form.reset();
    this.form.enable();

    let enabled = true;
    if (event.dataItem.enabled === 'F') {
      enabled = false;
    }

    this.form = this.formBuilder.group({

      id: event.dataItem.id,
      name: [event.dataItem.name, [Validators.required, Validators.minLength(2)]],
      description: [event.dataItem.description, [Validators.required, Validators.minLength(2)]],
      company: this.companiesItems[companyid],
      objectType: [event.dataItem.objectType],
      enabled: [enabled],

    });



    this.initialFormValues = this.form.value;
    this.readonly = false;

  }

  getAdminObjects(projectid: number) {
    this.loading = true;
    this.adminObjects = [];
    this.displayObjects = [];
    this.form.reset();
    this.selectedProjectId = projectid;



    this.portalAdminService.getObjectsAll(projectid).subscribe({
      next: (result) => {
        this.adminObjects = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //throw message of some sort
        console.log(error)
        this.loading = false;
      },
      complete: () => {
        this.displayObjects = this.adminObjects;
        this.loading = false;
        this.selection = this.selectedRowItem;
        this.form.disable();

        this.uploadbuttonstate = false;
        this.cdr.markForCheck();
        // console.log(JSON.stringify(this.displayObjects));
      }
    });
  }

  @ViewChild('nametext') nametext!: TextBoxComponent;
  onAddButtonClick() {

    this.form.reset();
    this.buildform();
    this.form.enable();
    this.selection = [];
    this.buttonhandle('Add');
    this.initialFormValues = this.form.value;

    setTimeout(() => {
      this.nametext.focus();
    }, 100);

  }

  objectdata: Objects = emptyObjects();

  objectData(): Objects {
    // this.form
    //    console.log(this.form);
    this.objectdata.id = this.form.value.id;
    this.objectdata.name = this.form.value.name;

    this.objectdata.description = this.form.value.description;
    this.objectdata.objectType = this.form.value.objectType;
    this.objectdata.projectId = this.selectedProjectId;
    this.objectdata.companyId = this.form.value.company.value;
    this.objectdata.companyName = this.form.value.company.text;
    console.log("this.form.value.enabled",this.form.value.enabled)
    if(this.form.value.enabled){
      this.objectdata.enabled = "T"
    }else{
      this.objectdata.enabled = "F"
    }
    

    return this.objectdata;
  }


  public rowCallback = (context: { dataItem: any, index: number }): string => {
    return context.dataItem.enabled === 'F' ? 'disabled-row' : '';
  };
  
  onSaveButtonClick() {
    this.selectedRowItem = [];
    this.buttonhandle('Save');



    if (this.form.get('id')?.value == null) {
      this.portalAdminService.addObject(this.selectedProjectId, this.objectData()).subscribe({
        next: (result) => {
          this.adminObject = result;
          this.cdr.markForCheck();
        },
        error: (error) => {
          //throw message of some sort
          //   console.log('Error :' + JSON.stringify(error.message))
          this.showError(JSON.stringify(error.message));
          this.loading = false;
        },
        complete: () => {
          //this.displayCompanies = this.adminCompanies;
          this.selectedRowItem = [this.adminObject.id];
          this.getAdminObjects(this.selectedProjectId);

          //console.log(JSON.stringify(this.adminCompany));
        }
      });
    } else {
      this.portalAdminService.updateObject(this.selectedProjectId, this.form.get('id')?.value, this.objectData()).subscribe({
        next: (result) => {
          this.adminObject = result;
          this.cdr.markForCheck();
        },
        error: (error) => {

          this.showError(JSON.stringify(error.message));
          this.loading = false;
        },
        complete: () => {

          this.selectedRowItem = [this.adminObject.id];
          this.getAdminObjects(this.selectedProjectId);

          //console.log(JSON.stringify(this.adminCompany));
        }
      });
    }
  }

  adminObject: Objects = emptyObjects();
  onRemoveButtonClick() {
    const popupErrorMessages = [
      'Cannot delete order: it is currently in use by one or more users.'
    ];
    this.portalAdminService.deleteObject(this.selectedProjectId, this.form.get('id')?.value).subscribe({
      next: (result) => {
        this.adminObject = result;
        this.cdr.markForCheck();
      },
      error: (error) => {
        //console.log('Error :' + JSON.stringify(error.message))
        //this.showError(JSON.stringify(error.message));
        const backendMessage = error?.error?.message || 'An unexpected error occurred.';
        if (popupErrorMessages.includes(backendMessage)) {
          this.errorMessage = backendMessage;
          this.showErrorDialog = true;
          this.cdr.markForCheck();
        } else {
          this.showErrorDialog = false;
          this.showError(backendMessage); // Show as red error
        }
        this.loading = false;
      },
      complete: () => {

        this.selectedRowItem = [];
        this.getAdminObjects(this.selectedProjectId);
        this.buttonhandle('Remove');
      }
    });
  }

  onUploadClick() {
    this.buttonhandle('Upload');
    this.openedexcelwindow = true;
    this.displayObjects = this.adminObjects;
  }

  orderEnabledChange(event: any) {
    this.form.patchValue({
      enabled: event.srcElement.checked
    });
    console.log(event)
    console.log("this.form",this.form.get('enabled')?.value)
    /*if (event.srcElement.checked) {
      this.changedUser.enabled = 'T'
    }*/
    
    this.formHasChanged();
  }


  nameChange() {
    const currentName = this.form.get('name')?.value;
    const isDuplicate = this.displayObjects.some(obj => obj.name === currentName);
    if (isDuplicate) {
      this.duplicateOrderName = true;
    } else {
      this.duplicateOrderName = false;
    }
    this.formHasChanged();
  }

  valueChange(event: any) {
    this.formHasChanged();
  }


  formHasChanged(): boolean {

    const checkvalue = Object.entries(this.initialFormValues).some(
      ([field, value]) => value !== this.form.value[field]
    );

    let name = this.form.get('name')?.value;
    let description = this.form.get('description')?.value;
    let company = this.form.get('company')?.value;
    // console.log(company);

    // let companyname=this.form.get('company')?.value;

    if (name != null && description != null && name.length > 1 && description.length > 1 && company.value > 0) {

      if (checkvalue && !this.duplicateOrderName) {
        this.savebuttonstate = false;
      } else {
        this.savebuttonstate = true;
      }
    }
    else {
      this.savebuttonstate = true;
    }
    // console.log(this.form.get('usertype')?.value);
    return checkvalue;
  }

  public showError(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 10000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "error", icon: true },
    });
  }
  public success(value: string): void {
    this.notificationService.show({
      content: value,

      hideAfter: 3000,
      position: { horizontal: "right", vertical: "top" },
      animation: { type: "slide", duration: 400 },
      type: { style: "success", icon: true },
    });
  }

  ngOnDestroy(): void {
    this.subscription.forEach((subs) => subs.unsubscribe());
  }
  addObject(data: Objects): Observable<Objects> { 
    
    this.loading = true;

    return this.portalAdminService
      .addObject(this.selectedProjectId, data)
      .pipe(
        tap((result: Objects) => {
          this.adminObject = result;
          this.selectedRowItem = [result.id];
          this.cdr.markForCheck();
        }),
        catchError((error) => {
          this.showError(JSON.stringify(error.message));
          return throwError(() => error);
        }),
        finalize(() => {
          this.loading = false;
        })
      );
  }
  companyChange(event: any) {
    if (this.selectedCompanyItem != event) {
      this.savebuttonstate = false;
    }
    this.formHasChanged();
  }

  // EXCEL input

  public items: SpreadsheetMainMenuItem[] = [{ id: "file", active: true }];
  openedexcelwindow: boolean = false;
  @ViewChild('spreadsheet') spreadsheet1!: SpreadsheetComponent;
  windowTitle: string = 'Portal Order(s) Load';
  exceldata: SheetDescriptor[] = [
    {
      name: "Objects",
      rows: [
        {
          cells: [
            {
              value: "Order No",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            },
            {
              value: "Order Description",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            },
            {
              value: "Company",
              fontSize: 14,
              background: "rgb(24, 37, 170)",
              color: "rgb(255,255,255)",
              bold: true,
              enable: false
            }
          ],
        },
        {
          cells: [{ value: "PO-101" },
          { value: "Pump 101" },
          { value: "Flowserve" }],
        },
      ],
      columns: [
        { index: 0, width: 130 },
        { index: 1, width: 170 },
        { index: 2, width: 170 }
      ],
    },
  ];
  onExcelClick() {
    this.buttonhandle('Upload');
    this.openedexcelwindow = true;
    this.uploadbuttonstate = true;
    this.addbuttonstate = true;
  }

  closeExcelWindow() {
    this.openedexcelwindow = false;
    this.uploadbuttonstate = false;
    this.addbuttonstate = false;
  }

  mySelection: number[] = [1];

  openedExcelwindow() {
    this.openedexcelwindow = true;

    setTimeout(() => {
      this.spreadsheet1.onMenuItemSelect("file");
    });
  }
  t!: SpreadsheetBackColorComponent;
  sheettrow!: SheetRow;
  cellStyle: CellDefaultStyle = {
    bold: true,
    underline: true,
    fontSize: 20,
    color: "#09a144",
  };
  headerValidation: boolean = false;
  spreadsheetObj!: SpreadsheetForeColorComponent;
  error!: string;
  value!: string;
  uploadObjects: Objects[] = [];
  uploadObject: Objects = emptyObjects();


  saveExcelSample(spreadsheet: SpreadsheetComponent): void {
    const data = spreadsheet.spreadsheetWidget.toJSON();
    this.uploadObjects = [];
    const sheet = data.sheets;
    const rows = sheet![0].rows || [];
    this.error = '';

    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].cells || [];

      if (i === 0) {
        this.headerValidation = this.validateHeader(rows[i]);
        if (!this.headerValidation) {
          this.error = 'Header validation failed.\n';
          break;
        }
        continue;
      }

      while (cells.length < 3) {
        cells.push({ value: '' });
      }

      const isEmptyRow = cells.every(cell => {
        const val = cell?.value?.toString().trim();
        return !val || val === '';
      });

      if (isEmptyRow) continue;

      let filledCount = 0;
      for (let j = 0; j < 3; j++) {
        const val = cells[j]?.value?.toString().trim();
        if (val && val !== '') {
          filledCount++;
        }
      }

      if (filledCount < 3) {
        this.error += `Row ${i}: not all fields have values (fieldcount ${filledCount})\n`;
        continue;
      }

      this.uploadObject = emptyObjects();
      for (let j = 0; j < 3; j++) {
        const rawValue = cells[j]?.value?.toString().trim();
        const value = rawValue && rawValue !== '' ? rawValue : '-';
        this.validateUpload(value, j);
      }

      this.uploadObject.projectId = this.selectedProjectId;
      this.uploadObject.objectType = 'Purchase Order';
      this.uploadObjects.push(this.uploadObject);
    }

    const nameSet = new Set<string>();

    for (const obj of this.uploadObjects) {
      const name = obj.name?.toString().trim();

      if (!name) continue;

      if (nameSet.has(name)) {
        this.error += `Multiple entries found: ${name}\n`;
      } else {
        nameSet.add(name);
      }
    }

    if (this.error.length > 0) {
      this.errorWindow = true;
      this.title = 'Error(s) - Orders Upload';
      this.content = this.error;
    } else {
      const userCount = this.uploadObjects.length;
      const dialog: DialogRef = this.dialogService.open({
        title: 'Confirmation - Objects Upload',
        content: `${userCount} Objects will be uploaded`,
        actions: [{ text: 'Cancel' }, { text: 'Save' }],
        width: 450,
        height: 200,
        minWidth: 250
      });

      dialog.result.subscribe((result: any) => {
        if (result.text === 'Cancel') {
          dialog.close();
        }
        if (result.text === 'Save') {
          /*for (const obj of this.uploadObjects) {
            const cleanObj = { ...obj };
            if (cleanObj.name) {
              cleanObj.name = cleanObj.name.replace(/,/g, '');
            }
            alert(3)
            this.addObject(cleanObj);
          }*/
          //this.closeExcelWindow();

          
          const addRequests = this.uploadObjects.map(obj => {
            const cleanObj = { ...obj };

            if (cleanObj.name) {
              cleanObj.name = cleanObj.name.replace(/,/g, '');
            }

            return this.addObject(cleanObj); // returns Observable
          });

          // WAIT FOR ALL OBJECTS TO BE ADDED
          forkJoin(addRequests).subscribe({
            next: (results) => {
              console.log('All objects added successfully', results);
            },
            error: (err) => {
              this.showError(JSON.stringify(err.message));
            },
            complete: () => {
              //CALLED ONLY ONCE
              this.getAdminObjects(this.selectedProjectId);
              this.closeExcelWindow();
            }
          });

        }
      });
    }
  }


  public get formattedErrorText(): string {
    return this.content
      .split('\n')
      .map(line =>
        line
          .split(':')
          .map(part => part.trim())
          .join('\t')
      )
      .join('\n');
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.formattedErrorText).then(() => {
      console.log('Copied to clipboard');
    });
  }

  validateHeader(value: any): boolean {

    let checkvalue: boolean = true;

    if (value.cells![0].value!.valueOf().toLocaleString().toUpperCase() != 'ORDER NO') {
      checkvalue = false;

    }
    if (value.cells![1].value!.valueOf().toLocaleString().toUpperCase() != 'ORDER DESCRIPTION') {
      checkvalue = false;
    }

    if (value.cells![2].value!.valueOf().toLocaleString().toUpperCase() != 'COMPANY') {
      checkvalue = false;
    }

    if (!checkvalue) {
      this.error = 'Wrong Temoplate Header. must contain [Order No,	Order Description, Company]'
    }
    return checkvalue;
  }

  validateUpload(value: string, field: number) {
    if (field == 0) {
      const i = this.adminObjects.findIndex((x) => x.name === value);

      if (i != -1) {
        this.error = this.error + 'Order already exists on the Project: ' + value + '\n';

      } else {
        this.uploadObject.name = value;
      }
    }

    if (field == 1) {
      if (value.valueOf().toLocaleString().length < 2) {
        this.error = this.error + 'Description needs at least 2 characters: ' + value + '\n';

      }
      else {
        this.uploadObject.description = value;

      }
    }
    if (field == 2) {
      let companyid = this.companiesItems.findIndex(x => x.text.toUpperCase() === value.toUpperCase());
      if (companyid == -1) {
        this.error = this.error + 'Company not found: ' + value + '\n';
      }
      else {
        this.uploadObject.companyName = this.companiesItems[companyid].text;
        this.uploadObject.companyId = this.companiesItems[companyid].value;
      }
    }
  }

  onExcelChange(event: SpreadsheetChangeEvent, type: string) {
    console.log(event);
  }

  public onExcelExport(event: SpreadsheetExcelExportEvent): void {
    console.log(`excelExport`);
    console.log(event);
  }

  public onActiveSheetChange(event: SpreadsheetChangeEvent): void {
    console.log(`activeSheetChange`);
    console.log(event);
  }

  public jsonData!: DocumentDescriptor;

  public onSave(spreadsheet: SpreadsheetComponent): void {
    spreadsheet.spreadsheetWidget.saveJSON().then((data) => {
      this.jsonData = data;
    });
  }
  getFileName() {
    let str = 'Portal Purchase Orders';
    if (this.project?.projectnumber! != null) {
      console.log("this.project?.projectnumber",this.project?.projectnumber)
      return `${this.project.projectnumber}_${str} ${this.getFormattedDate()}.xlsx`;
    }
    return `${str} ${this.getFormattedDate()}.xlsx`
  }
  getFormattedDate(): string {
    const date = new Date();
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  exportAll(e: any): void {
    const headerRow = {
      cells: [
        { value: 'ID', background: '#808080', color: '#FFFFFF' },
        { value: 'Order No', background: '#808080', color: '#FFFFFF' },
        { value: 'Order Description', background: '#808080', color: '#FFFFFF' },
        { value: 'Company', background: '#808080', color: '#FFFFFF' },
      ]
    };

    const filtered = (this.displayObjects || []).filter(item => item.enabled === 'T');
    const dataRows = filtered.map(item => ({
      cells: [
        { value: item.id },
        { value: item.name },
        { value: item.description },
        { value: item.companyName }
      ]
    }));

    e.workbook.sheets[0].rows = [headerRow, ...dataRows];
  }

   

}
